import { Stack, styled } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';

export const StyledSection = styled(Section)(({ theme }) => ({
  marginBottom: theme.spacing(8),
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(4),
  },
}));

export const StyledContent = styled(Stack)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(8),
  margin: theme.spacing(8, 0, 0, 0),
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(4),
    margin: theme.spacing(4, 0, 0, 0),
    flexDirection: 'column',
  },
}));
